import { PRODUCT_LINE_CODE } from '../../../shared/constants/product-lines-codes';
import { cementBag } from './cement-bag';

export const esConfig = {
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
  profilesTable: {
    hidePayment: true,
    hidePlant: true,
  },
};
